import Vue from 'vue'
const selectRadio = new Vue()
export default selectRadio